var _path, _path2, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9658 15.0627C22.9658 13.7282 23.1085 12.3057 22.9658 10.9767C22.8861 10.2342 22.3236 9.45395 21.9953 8.80013C21.6502 8.11263 21.3051 7.42519 20.96 6.73774C21.5792 6.2852 21.9658 5.70658 21.9658 4.98808C21.9658 2.93523 18.8555 2 15.9658 2C13.0762 2 9.96581 2.93523 9.96581 4.98808C9.96581 5.70658 10.3524 6.28521 10.9717 6.73774C10.3486 7.97901 9.72545 9.22021 9.10235 10.4615C9.0985 10.4692 9.09991 10.4763 9.09625 10.484C9.0202 10.6185 8.96582 10.7722 8.96582 10.9642V25.4087C8.96582 26.474 9.57141 27.0026 10.3723 27.6571C12.1383 29.1002 14.3675 30.1707 16.7054 29.9774C18.28 29.8472 19.7129 29.2098 20.9522 28.2484C21.7304 27.6447 22.9199 26.8127 22.9658 25.7556C23.1201 22.2056 22.9658 18.6158 22.9658 15.0627ZM15.9658 3.99204C18.313 3.99204 19.6831 4.66222 19.9409 4.98807C19.6831 5.31391 18.313 5.98409 15.9658 5.98409C13.6186 5.98409 12.2485 5.31391 11.9907 4.98807C12.2485 4.66222 13.6186 3.99204 15.9658 3.99204ZM20.9658 12.6654V25.5166C19.0473 27.5337 16.5748 28.6767 13.8293 27.4956C12.7747 27.0418 11.7722 26.3357 10.9658 25.4992V11.1949C11.5044 10.122 12.0431 9.04914 12.5817 7.97615H19.342C19.8651 9.04743 20.3666 10.1391 20.9542 11.1718C20.9572 11.1771 20.9579 11.1787 20.9608 11.1837C20.9639 11.2194 20.9666 11.2506 20.9658 11.263C20.9363 11.7263 20.9658 12.2013 20.9658 12.6654ZM20.9998 11.2543C21.0584 11.3912 21.1185 11.4699 20.9998 11.2543Z",
    fill: "url(#paint0_linear_1277_464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9658 15.9443C19.9658 15.4059 19.5077 14.9483 18.9658 14.9483H12.9658C12.4252 14.9483 11.9658 15.4047 11.9658 15.9443V24.8726C11.9532 25.0137 11.9819 25.1573 12.0455 25.2987C12.0822 25.3869 12.139 25.4549 12.1974 25.5226C12.222 25.5521 12.2295 25.5843 12.2587 25.6129C12.2643 25.6183 12.2712 25.6224 12.2768 25.6278L12.2812 25.6315C13.401 26.7072 15.2233 27.0312 16.7067 26.8524C17.7465 26.7271 19.9047 26.2138 19.9658 24.857C20.0617 22.7297 19.9658 20.5767 19.9658 18.4473L19.9658 15.9443ZM17.9658 24.3929C17.8816 24.4445 17.8009 24.5017 17.7111 24.5465C17.266 24.7685 16.5693 24.9086 15.9658 24.9086C15.3605 24.9086 14.6686 24.77 14.2205 24.5465C14.1307 24.5018 14.05 24.4446 13.9658 24.3929V16.9404H17.9658V24.3929Z",
    fill: "url(#paint1_linear_1277_464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1277_464",
    x1: 23.0446,
    y1: 16,
    x2: 8.96582,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1277_464",
    x1: 23.0446,
    y1: 16,
    x2: 8.96582,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionIcon);
export default __webpack_public_path__ + "static/media/productionIcon.498b3679708128ed6cece50486384218.svg";
export { ForwardRef as ReactComponent };